var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('Colophon'),_c('div',{staticClass:"divider"}),_c('Music',{attrs:{"songs":_vm.songs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }